// utils/creditCardValidation.js

// Regex para detectar bandeiras
const BANDEIRAS_REGEX = {
  visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
  mastercard: /^5[1-5][0-9]{14}$/,
  amex: /^3[47][0-9]{13}$/,
  hipercard: /^(606282\d{10}(\d{3})?)|(3841\d{15})$/, 
  elo: /^((636368)|(438935)|(504175)|(451416)|(636297)|(5067)|(4576)|(4011))\d{0,16}$/,
};

// Lista de bandeiras aceitas
export const BANDEIRAS_ACEITAS = [
  "visa",
  "mastercard",
  "amex",
  "hipercard",
  "elo",
];

// Função para detectar a bandeira pelo número do cartão (apenas quando completo)
export const detectarBandeira = (numeroCartao) => {
  if (!numeroCartao || numeroCartao.length < 13) return null;

  const numeroLimpo = numeroCartao.replace(/\s/g, "");

  // Só detecta bandeira quando o número está completo ou quase completo
  if (numeroLimpo.length < 13) return null;

  for (const [bandeira, regex] of Object.entries(BANDEIRAS_REGEX)) {
    if (regex.test(numeroLimpo)) {
      return bandeira;
    }
  }

  return "Bandeira não aceita";
};

// Função para verificar se o número está completo o suficiente para validação
export const isNumeroCompleto = (numeroCartao) => {
  if (!numeroCartao) return false;
  const numeroLimpo = numeroCartao.replace(/\s/g, "");
  return numeroLimpo.length >= 13 && numeroLimpo.length <= 19;
};

// Função para detecção provisória de bandeira (apenas pelo prefixo)
export const detectarBandeiraProvisoria = (numeroCartao) => {
  if (!numeroCartao || numeroCartao.length < 6) return null;

  const numeroLimpo = numeroCartao.replace(/\s/g, "");
  const prefixo = numeroLimpo.substring(0, 6);

  // Prefixos comuns para detecção precoce
  const prefixos = {
    visa: /^4/,
    mastercard: /^(5[1-5]|2[2-7])/,
    amex: /^3[47]/,
    hipercard: /^(606282|3841)/,
    elo: /^(636368|438935|504175|451416|636297|5067|4576|4011)/,
  };

  for (const [bandeira, regex] of Object.entries(prefixos)) {
    if (regex.test(prefixo)) {
      return bandeira;
    }
  }

  return null;
};

// Algoritmo de Luhn para validar número do cartão
export const validarNumeroCartao = (numeroCartao) => {
  const numeroLimpo = numeroCartao.replace(/\s/g, "");

  if (!/^[0-9]{13,19}$/.test(numeroLimpo)) return false;

  let sum = 0;
  let shouldDouble = false;

  for (let i = numeroLimpo.length - 1; i >= 0; i--) {
    let digit = parseInt(numeroLimpo.charAt(i));

    if (shouldDouble) {
      if ((digit *= 2) > 9) digit -= 9;
    }

    sum += digit;
    shouldDouble = !shouldDouble;
  }

  return sum % 10 === 0;
};

// Validar data de expiração
export const validarDataExpiracao = (dataExpiracao) => {
  if (!/^\d{2}\/\d{2}$/.test(dataExpiracao)) return false;

  const [mes, ano] = dataExpiracao.split("/").map(Number);
  const agora = new Date();
  const anoAtual = agora.getFullYear() % 100;
  const mesAtual = agora.getMonth() + 1;

  // Validar mês
  if (mes < 1 || mes > 12) return false;

  // Validar ano
  if (ano < anoAtual) return false;
  if (ano === anoAtual && mes < mesAtual) return false;

  return true;
};

// Validar CVV baseado na bandeira
export const validarCVV = (cvv, bandeira) => {
  if (!cvv || !/^\d+$/.test(cvv)) return false;

  const comprimentos = {
    visa: 3,
    mastercard: 3,
    amex: 4,
    hipercard: 3,
    elo: 3,
    unknown: 3, // padrão
  };

  const comprimentoEsperado = comprimentos[bandeira] || 3;
  return cvv.length === comprimentoEsperado;
};

// Verificar se bandeira é suportada
export const isBandeiraSuportada = (bandeira) => {
  return BANDEIRAS_ACEITAS.includes(bandeira);
};
